import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { TextField, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        paddingBottom: "20px",
        paddingLeft: "15px"
    },
    input:
        { minWidth: '100%' }
}));

const UDFDateTime = (props) => {
    const { UDF } = props;
    const classes = useStyles();
    const [udfValue, setUdfValue] = useState("");

    useEffect(() => {
        setUdfValue(GetUserMemberValue());
    }, [UDF]);

    const onChangeHandler = (event) => {
        props.changecontrolvalue(event, props.bookingID, UDF.UDFCategoryName, UDF.UDFID);
    }

    const onChangeInput = (e) => {

        if (e.nativeEvent.target.defaultValue === e.nativeEvent.target.value) {

            e.nativeEvent.target.defaultValue = "";
            e.nativeEvent.target.value = "";

            setTimeout(onChangeHandler(e), 0);

        }
    }

    const GetUserMemberValue = () => {
        if (props.isMembership) {
            let userV = "";

            if (UDF.Users.filter(x => x.userID == props.usernumber).length > 0) {
                let user = UDF.Users.find(x => x.userID == props.usernumber);

                if (user && user.hasOwnProperty('userUDFValue')) {
                    userV = user.userUDFValue;
                }

                return userV;
            }
        }
        else {
            return UDF.Value;
        }
    }

    return (
        <div className={classes.root}>
            <Typography variant="subtitle1">{UDF.UdfDescription}</Typography>
            <TextField
                className={classes.input}
                id={UDF.UDFID.toString()}
                name={UDF.UDFID.toString()}
                label={UDF.Name}
                type="date"
                value={udfValue}
                required={UDF.IsRequired}
                InputLabelProps={{
                    shrink: true,
                    style: { padding: "0 0 0 15px" },
                }}
                defaultValue=""
                onChange={onChangeHandler}
                onInput={(e) => onChangeInput(e)}
                {...props}
            />
        </div>
    );
};

UDFDateTime.propTypes = {
    UDF: PropTypes.object.isRequired
};

export default UDFDateTime;
